// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Breadcrumbs_wrapper__2mwRO","item":"Breadcrumbs_item__YXdOc","link":"Breadcrumbs_link__3RQMZ"};